import {
  IAutomatedNotification,
  IAutomation,
  IGeneratedTask,
  IMarketingCampaign,
  IMarketingCampaignRun,
  IMarketingCampaignStep,
  IMarketingCampaignStepConversion,
  MarketingCampaignStepConversionStatus,
} from '@principle-theorem/principle-core/interfaces';
import { BaseMock, Properties, toTimestamp } from '@principle-theorem/shared';
import { MockDocRef } from '@principle-theorem/testing';

export class CampaignStepConversionMock
  extends BaseMock<Properties<IMarketingCampaignStepConversion>>
  implements Properties<IMarketingCampaignStepConversion>
{
  campaignRef = MockDocRef<IMarketingCampaign>();
  campaignRunRef = MockDocRef<IMarketingCampaignRun>();
  automationRef =
    MockDocRef<IAutomation<IAutomatedNotification | IGeneratedTask>>();
  stepRef = MockDocRef<IMarketingCampaignStep>();
  status = MarketingCampaignStepConversionStatus.Completed;
  completedAt = toTimestamp();
  deleted = false;
  estimatedCost = 0;
  estimatedCostRemaining = 0;
  estimatedSegments = 0;
  incurredCost = 0;
  estimatedRunDate = toTimestamp();
}
